import HonjoUpload from './HonjoUpload.vue'

export { HonjoUpload }
